import Image from "next/image";
import type { CatalogItem } from "@/lib/airtable";
import { ItemStatusTag } from "@/components/ItemStatusTag";

type Props = {
  item: CatalogItem;
  imageFit?: "cover" | "contain";
};

export function CatalogCard({ item, imageFit = "contain" }: Props) {
  const imageClassName = imageFit === "contain" ? "object-contain" : "object-cover";
  const frameClassName = imageFit === "contain" ? "bg-white" : "bg-slate-100";

  return (
    <article className="glass shadow-soft rounded-3xl overflow-hidden border border-slate-200 w-full max-w-lg mx-auto max-h-[65vh] flex flex-col">
      <div className={`relative ${frameClassName} aspect-square`}>
        <ItemStatusTag soldOut={item.soldOut} inPossession={item.inPossession} className="absolute left-3 top-3 z-10" />
        {item.pictureUrl ? (
          <Image
            src={item.pictureUrl}
            alt={item.itemName || "Jewelry item"}
            fill
            unoptimized
            className={imageClassName}
            sizes="(max-width: 640px) 90vw, 420px"
            priority
          />
        ) : (
          <div className="flex h-full items-center justify-center text-sm text-slate-400">
            Image coming soon
          </div>
        )}
      </div>
      <div className="p-5 space-y-4 flex-1">
        <h2 className="text-xl font-semibold text-slate-900 leading-tight">
          {item.itemName || "Untitled piece"}
        </h2>
      </div>
    </article>
  );
}
